// 一些公用的vux
import { getSession, setSession } from '@/utils';
import {
  LIST_PAGE_SEARCH_PARAMS,
} from '../mutation-types';

// 状态
const state = {
  // 列表页搜索条件
  listPageSearchParams: null,
};

// 操作
const mutations = {
  // 列表页搜索条件
  [LIST_PAGE_SEARCH_PARAMS](state, array) {
    state.listPageSearchParams = array;
    setSession('listPageSearchParams', array);
  },
};

// 方法
const actions = {
  // 设置列表页搜索条件
  setListPageSearchParams({ commit }, listPageSearchParams) {
    commit('LIST_PAGE_SEARCH_PARAMS', listPageSearchParams);
  },
};

const getters = {
  // 列表页搜索条件
  listPageSearchParams: state => state.listPageSearchParams || getSession('listPageSearchParams'),
};

export default {
  // 开启命名空间
  namespaced: true,
  getters,
  state,
  mutations,
  actions
};
